import React from "react"
import { Link } from "react-router-dom"
import { Col, Container, Row } from "reactstrap"
import { SupportPhonePair } from "../SupportContactPhones"
import {
  SUPPORT_COMPANY_LEGAL_NAME,
  SUPPORT_EMAIL,
  SUPPORT_MAILTO,
} from "../../config/supportContact"

const PROPERTY_TYPES = ["Office", "Industrial", "Land", "Retail", "Other"] as const
const EXTRA_LEGAL_LINKS = ["Disclaimer", "Accessibility"] as const

type Props = {
  /** Optional extra classes on `<footer>` (e.g. page-specific SCSS hooks) */
  className?: string
}

const SoldxLandingFooter = ({ className = "" }: Props) => {
  const year = new Date().getFullYear()
  const footerClass = ["soldx-footer", className].filter(Boolean).join(" ")

  return (
    <footer className={footerClass}>
      <div className="soldx-footer-top">
        <div className="container">
          <Row className="g-4">
            <Col md={6} lg={3}>
              <h4 className="soldx-footer-heading">Contacts</h4>
              <ul className="soldx-footer-list">
                <li>{SUPPORT_COMPANY_LEGAL_NAME}</li>
                <li>
                  <Link to="/contact-us">Contact Us</Link>
                </li>
                <li>
                  <SupportPhonePair />
                </li>
                <li>
                  <a href={SUPPORT_MAILTO}>{SUPPORT_EMAIL}</a>
                </li>
              </ul>
              <div className="soldx-footer-social">
                <a href="#fb" aria-label="Facebook">
                  <i className="ri-facebook-fill" />
                </a>
                <a href="#tw" aria-label="Twitter">
                  <i className="ri-twitter-fill" />
                </a>
                <a href="#ig" aria-label="Instagram">
                  <i className="ri-instagram-line" />
                </a>
                <a href="#in" aria-label="LinkedIn">
                  <i className="ri-linkedin-fill" />
                </a>
              </div>
            </Col>

            <Col md={6} lg={3}>
              <h4 className="soldx-footer-heading">All Properties</h4>
              <ul className="soldx-footer-list">
                {PROPERTY_TYPES.map((item) => (
                  <li key={item}>
                    <Link to={`/properties?type=${item}`}>{item}</Link>
                  </li>
                ))}
              </ul>
            </Col>

            <Col md={6} lg={3}>
              <h4 className="soldx-footer-heading">Legal</h4>
              <ul className="soldx-footer-list">
                <li>
                  <Link to="/terms-and-conditions">Terms & Conditions</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/about-us">About Us</Link>
                </li>
                <li>
                  <Link to="/contact-us">Contact Us</Link>
                </li>
                {EXTRA_LEGAL_LINKS.map((item) => (
                  <li key={item}>
                    <a href={`#${item.toLowerCase().replace(/\s+/g, "-")}`}>{item}</a>
                  </li>
                ))}
              </ul>
            </Col>

            <Col md={6} lg={3}>
              <h4 className="soldx-footer-heading">Explore</h4>
              <ul className="soldx-footer-list">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/seller">Seller</Link>
                </li>
                <li>
                  <Link to="/buyer">Buyer</Link>
                </li>
                <li>
                  <Link to="/broker">Broker</Link>
                </li>
              </ul>
            </Col>
          </Row>
        </div>
      </div>
      <div className="soldx-footer-bottom">
        <Container>
          <p className="soldx-footer-copy">© {year} SoldX. All Rights Reserved.</p>
        </Container>
      </div>
    </footer>
  )
}

export default SoldxLandingFooter
